import { render, staticRenderFns } from "./ListView2.vue?vue&type=template&id=db342b1a&scoped=true&"
import script from "./ListView2.vue?vue&type=script&scoped=true&lang=js&"
export * from "./ListView2.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./ListView2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ListView2.vue?vue&type=style&index=1&id=db342b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../NodeModules/Ljbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db342b1a",
  null
  
)

export default component.exports